import { useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import logoPrimary from '../../assets/images/logo-primary.png';
import logoHorizontal from '../../assets/images/logo-horizontal.png';
import './Login.css';

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [remember, setRemember] = useState(true);
  const [erro, setErro] = useState('');
  const [enviando, setEnviando] = useState(false);

  if (user) return <Navigate to="/dashboard" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setEnviando(true);
    try {
      await login(email, senha);
    } catch {
      setErro('Email ou senha inválidos.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="login-page">
      {/* ===== Painel esquerdo — marca ===== */}
      <div className="login-brand">
        <div className="login-brand__bars" aria-hidden="true">
          <i className="login-brand__bar login-brand__bar--1" />
          <i className="login-brand__bar login-brand__bar--2" />
          <i className="login-brand__bar login-brand__bar--3" />
        </div>

        <div className="login-brand__hero">
          <img src={logoPrimary} alt="AM Gestão" className="login-brand__logo" />
          <div className="login-brand__rule" />
          <p className="login-brand__text">
            Plataforma de gestão da jornada de acreditação hospitalar com base nos padrões da
            ONA.
          </p>
        </div>

        <div className="login-brand__footer">
          Desenvolvido por <strong>Datafit</strong>
        </div>
      </div>

      {/* ===== Painel direito — formulário ===== */}
      <div className="login-form-panel">
        <div className="login-form-inner">
          <div className="login-form__logo">
            <img src={logoHorizontal} alt="AM Gestão" />
          </div>

          <h1 className="login-form__title">Bem-vindo de volta</h1>
          <p className="login-form__subtitle">Entre com suas credenciais para acessar o portal.</p>

          <form className="login-form__fields" onSubmit={handleSubmit}>
            <label className="am-field">
              <div className="am-field__label-row">
                <span className="am-field__label">E-mail</span>
              </div>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="voce@instituicao.com.br"
                autoComplete="username"
                required
              />
            </label>

            <label className="am-field">
              <div className="am-field__label-row">
                <span className="am-field__label">Senha</span>
                <button
                  type="button"
                  className="am-field__toggle"
                  onClick={() => setShowPw((v) => !v)}
                >
                  <span className="ms">{showPw ? 'visibility_off' : 'visibility'}</span>
                  {showPw ? 'Ocultar' : 'Mostrar'}
                </button>
              </div>
              <input
                type={showPw ? 'text' : 'password'}
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                placeholder="••••••••••"
                autoComplete="current-password"
                required
              />
            </label>

            <div className="login-form__options">
              <button
                type="button"
                className="am-checkbox"
                onClick={() => setRemember((v) => !v)}
              >
                <span className={`am-checkbox__box${remember ? ' is-checked' : ''}`}>
                  {remember && <span className="ms">check</span>}
                </span>
                Manter conectado
              </button>
              <Link to="/esqueci-senha" className="login-form__forgot">
                Esqueceu a senha?
              </Link>
            </div>

            {erro && <div className="login-form__error">{erro}</div>}

            <button type="submit" className="am-btn-primary" disabled={enviando}>
              <span className="ms">login</span>
              {enviando ? 'ENTRANDO...' : 'ENTRAR'}
            </button>
          </form>

          <div className="login-form__footer">ACF Moura · Consultoria ONA © 2026</div>
        </div>
      </div>
    </div>
  );
}
